<template>
  <div class="odd-even" style="display: table-row;">
    <div class="flex-cell">
      <div class="font-weight-bold">
        <v-icon small color="text" style="transition: none;">mdi-barcode</v-icon>
        {{ item.batch_number || '&nbsp;' }}
      </div>
      <div class="caption">
        <router-link
        class="rlink-hover green--text"
        style="text-decoration: none;display:inline-flex;align-items: center;"
        :to="{ path: '/trace/' + item.id}" @click.native.stop>
          <v-icon small color="green" style="transition: none;">mdi-qrcode-scan</v-icon>
          <span class="ml-1">{{ item.id }}</span>
        </router-link>
      </div>
    </div>
    <div class="flex-cell">
      <div class="font-weight-bold">
        <div v-if="inventory.length === 0">
          Out of stock
        </div>
        <c-metric-selector
        v-else-if="item.inventory !== 0"
        :realValue="item.inventory"
        :inventoryItemID="item.inventory_item_id" 
        :alwaysScale="true"
        :key="item.inventory_item_id"
        labelMode
        ></c-metric-selector>
        <span v-else class="red--text">
          Out of stock
        </span>
      </div>
      <div v-if="inventory.length === 0" class="caption">
        <span
        @click.stop="$emit('returnToInventory', item)"
        class="rlink-hover blue--text text--darken-1">
          Return to inventory
        </span>
      </div>
    </div>
    <div class="flex-cell">
      <div class="font-weight-bold">
        {{ dateOfEntryHuman || '&nbsp;' }}
      </div>
      <div class="caption">
        {{ dateOfEntry || '&nbsp;' }}
      </div>
    </div>
    <div class="flex-cell">
      <div class="font-weight-bold">
        {{ expiryDateHuman || '&nbsp;' }}
      </div>
      <div class="caption">
        {{ expiryDate || '&nbsp;' }}
      </div>
    </div>
    <div class="flex-cell">
      <div class="font-weight-bold">
        {{ supplier.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    inventory () {
      return Object.values(this.$store.state.db.inventory.inventory).filter(invItem => invItem.archive_id === this.item.id)
    },
    supplier () {
      return this.$store.state.db.suppliers.suppliers[this.item.supplier_id] || {}
    },
    dateOfEntry () {
      if (this.$moment.utc(this.item.date_of_entry).isValid()) {
        return this.$moment(this.item.date_of_entry).format('DD/MM/YYYY')
      }
      return ''
    },
    dateOfEntryHuman () {
      if (this.$moment.utc(this.item.date_of_entry).isValid()) {
        return this.$moment.utc(this.item.date_of_entry).fromNow()
      }
      return ''
    },
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD/MM/YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment.utc(this.item.expiry_date).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.flex-cell {
  display: table-cell;
  height: 56px;
  border-right: 1px solid #dadce0;
  padding: 8px 12px 8px 16px;
  &:last-child {
    border-right: none;
  }
}
.odd-even:nth-child(odd) {
  background: #f1f3f4;
  background: rgb(250, 250, 250);
}
</style>

